<template>
  <div>
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="抄表列表" name="MeterNoteList">
        <MeterNoteList v-if="card_index==='MeterNoteList'" />
      </el-tab-pane>
      <el-tab-pane label="在线抄表" name="MeterNoteWrite">
        <MeterNoteWrite v-if="card_index==='MeterNoteWrite'"/>
      </el-tab-pane>
      <el-tab-pane label="批量导入" name="MeterImport" >
        <MeterNoteImport v-if="card_index==='MeterImport'" />
      </el-tab-pane>
      <el-tab-pane label="抄表明细" name="MeterNoteDetail" v-if="ERP.isPermission(4007003003)||ERP.isPermission(8006002003)||ERP.isPermission(21004002003)">
        <MeterNoteDetail v-if="card_index==='MeterNoteDetail'" />
      </el-tab-pane>
      <el-tab-pane label="仪表能耗图" name="MeterNoteMapList">
        <MeterNoteMapList v-if="card_index==='MeterNoteMapList'" />
      </el-tab-pane>
      <el-tab-pane label="拍照读数" name="MeterOcr">
        <MeterOcr v-if="card_index==='MeterOcr'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MeterNoteList from "./MeterNoteList";
import MeterNoteImport from "./MeterNoteImport";
import MeterNoteWrite from "./MeterNoteWrite";
import MeterNoteDetail from "./MeterNoteDetail";
import MeterNoteMapList from "./MeterNoteMapList";
import MeterOcr from "./MeterOcr";
export default {
  name: "MeterNoteMain",
  components: {MeterOcr, MeterNoteMapList, MeterNoteDetail, MeterNoteWrite, MeterNoteImport, MeterNoteList},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      card_index:"MeterNoteList"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/MeterNoteMain.vue